import {
  CancelOutlinedIcon,
  CheckCircleOutlineRoundedIcon,
  DoNotDisturbOnOutlinedIcon,
  ErrorOutlineIcon,
  PendingOutlinedIcon,
  PendingActionsOutlined,
  Text,
} from '@shared/components';

export type ExamineeProgressIconVariant =
  | 'completed'
  | 'in-progress'
  | 'pending'
  | 'canceled'
  | 'expired'
  | 'not-required'
  | 'disabled';

interface ExamineeProgressIconProps {
  variant: ExamineeProgressIconVariant;
}

export default function ExamineeProgressIcon(props: Readonly<ExamineeProgressIconProps>) {
  const { variant } = props;

  switch (variant) {
    case 'completed':
      return (
        <CheckCircleOutlineRoundedIcon
          sx={(theme) => ({
            color: theme.palette.success.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case 'canceled':
      return (
        <CancelOutlinedIcon
          sx={(theme) => ({
            color: theme.palette.error.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case 'in-progress':
      return (
        <PendingOutlinedIcon
          sx={(theme) => ({
            color: theme.palette.warning.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case 'pending':
      return (
        <PendingActionsOutlined
          sx={(theme) => ({
            color: theme.palette.info.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case 'expired':
      return (
        <ErrorOutlineIcon
          sx={(theme) => ({
            color: theme.palette.error.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case 'not-required':
      return (
        <Text
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            textAlign: 'left',
          })}
        >
          {'  - '}
        </Text>
      );
    case 'disabled':
    default:
      return (
        <DoNotDisturbOnOutlinedIcon
          sx={(theme) => ({
            color: theme.palette.grey[500],
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
  }
}
